import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { Kullanici } from '../models/kullanici.model';
import { Profil } from '../models/profil.model';
import { Token } from '../models/token.model';
import { GirisService } from './giris.service';
import { ProfilService } from './profil.service';

@Injectable({
  providedIn: 'root'
})
export class YetkiService {
  
  telDogrulama: boolean =  false;
  mernisDogrulama:boolean= false;
  constructor(private toastr:ToastrService,private profilService:ProfilService, public girisService:GirisService ) { }

  yetkiVar(yetkiler: string | string[]): boolean {
    if (typeof (yetkiler) == 'string') {
      yetkiler = [yetkiler];
    }

   // const token = JSON.parse(localStorage.getItem('auth')!) as Token;
   //const auth = document.cookie.split('=')[1];

   const token = JSON.parse(this?.girisService.cookieByName()) as Token;
    const roller = (jwtDecode(token.token) as Kullanici).Rol;
    for (const yetki of yetkiler) {
      if (!roller.includes(yetki)) {
        return false;
      }
    }
    return true;
  }

  bilgiGirmeDurum():Promise<boolean>{
    var idint: number = +this.girisService.girisBilgi().kullanici_id;

   return this.profilService.getById(idint).toPromise().then(res => {
      this.telDogrulama=res?.telDogrulama!;
      this.mernisDogrulama=res?.mernisDogrulama!;
      return this.telDogrulama&& this.mernisDogrulama;   

      });
      // if(this.telDogrulama==true && this.mernisDogrulama==true)
      // return false;     
   
  }

  success(mesaj : string,beklemezamani : number) {
    this.toastr.success(mesaj);
  }
  
  error(mesaj : string,beklemezamani : number) {
    this.toastr.error(mesaj);
  }
}
